import React, {useState} from "react";
import "./styles.css";
import { 
    cliente01Color,
    construcciones,
    offshore,
    jaktur,
    polloLoco} from './NuestrosClientesLogos/imagenes'

export default function NuestrosClientes(props) {

    return (
        <>
            <div className="contenedorClientes">

            <div className='cTituloClientesInicio'>
            <h2>
                NUESTROS CLIENTES
            </h2>
            </div>

                <div className="filasClientes">
                    <div className="contenedorCardClientes">
                        <img
                            src={construcciones}
                            className="contenedorImagenClientes"
                        />
                    </div>
                    <div className="contenedorCardClientes">
                        <img
                            src={offshore}
                            className="contenedorImagenClientes"
                        />
                    </div>
                    <div className="contenedorCardClientes">
                        <img
                            src={jaktur}
                            className="contenedorImagenClientes"
                        />
                    </div>
                    <div className="contenedorCardClientes">
                        <img
                            src={polloLoco}
                            className="contenedorImagenClientes"
                        />
                    </div>

                </div>
            </div>
        </>
    );
}
